(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Ticket_statusDetailController', Ticket_statusDetailController);

    Ticket_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket_status'];

    function Ticket_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket_status) {
        var vm = this;

        vm.ticket_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:ticket_statusUpdate', function(event, result) {
            vm.ticket_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
